import { IonAvatar } from '@ionic/react';
import clsx from 'clsx';
import React, { memo } from 'react';
import { transformToAge } from '../../../utils/helperFunction/transformDate';

type Props = {
  isOnline: boolean;
  fullName: string;
  profilePicture: string;
  lastSeen?: string | null;
};
const ChatTitle = memo(function ({
  isOnline,
  fullName,
  profilePicture,
  lastSeen,
}: Props) {
  const availabilityStyle = clsx(
    'absolute  w-3 h-3 border-2  bottom-0 right-0 rounded-full z-10',
    isOnline ? 'bg-green-500 border-green-50' : 'bg-gray-500 border-gray-50'
  );
  return (
    <div className="p-2  flex items-center gap-2">
      <div className="relative w-fit">
        <div className={availabilityStyle} />
        <IonAvatar className="h-fit w-fit border border-border">
          <img
            src={profilePicture}
            color="red"
            className="w-10 min-w-10 h-10 min-h-10"
          />
        </IonAvatar>
      </div>

      <span className="flex-1 space-y-1">
        <h6 className="capitalize leading-none truncate font-semibold text-customs-dark-blue">
          {fullName}
        </h6>
        {lastSeen && (
          <small className="medium-emphasis-text">
            {transformToAge(lastSeen)}
          </small>
        )}
      </span>
    </div>
  );
});

export default ChatTitle;

export function ChatTitleSkeleton() {
  return (
    <div className="p-2  flex items-center gap-2">
      <div className="w-10 min-w-10 h-10 min-h-10 bg-gray-50 rounded-full animate-pulse" />
      <span className="flex-1 space-y-1">
        <h6 className="text-gray-50 bg-gray-50 animate-pulse">
          recipient fullName
        </h6>
        <small className="text-gray-50 bg-gray-50 animate-pulse">
          last seen
        </small>
      </span>
    </div>
  );
}
